import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export default function SiteFooter() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-line bg-white/50 backdrop-blur-sm py-8 mt-24">
      <div className="wrap flex flex-col md:flex-row items-center justify-between gap-2 text-[12px] text-tert">
        <div>© {new Date().getFullYear()} Chiessa Institute · {t("footer")}</div>
        <a
          href="https://www.dataismo.ai/"
          target="_blank"
          rel="noreferrer"
          className="hover:text-teal-deep transition"
          data-testid="site-footer-dataismo"
        >
          www.dataismo.ai
        </a>
      </div>
    </footer>
  );
}
